module.exports = __webpack_public_path__ + "static/img/pass.02153b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pass.png
// module id = Qsw/
// module chunks = 1